module.exports = __webpack_public_path__ + "static/media/TTF.3ccf1ef3.svg";